import { observable } from "mobx";
import { api, api_adm, apiOperacao } from "../../api";
import { toast } from "react-toastify";

class _CstOrigemStore {

  obs = observable({
    cst_origem: [] as any,
    loading: false as boolean
  })

  async handleLoadCstOrigem() {

    try {

      let resp = await apiOperacao("legislacoes").get("/legislacoes/codigos/cst/origem")

      this.obs.cst_origem = []

      if (resp.data.length) {

        this.obs.cst_origem = resp.data

      }

    } catch (ex) {}

  }

  get(codigo: string) {

    return this.obs.cst_origem.find(x => x.codigo == codigo);

  }

  async handleCreateCstOrigem(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/cst/origem/create", data)

    if (resp.data.ok) {

      toast.success('CST Origem criado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

  async handleUpdateCstOrigem(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/cst/origem/update", data)

    if (resp.data.ok) {

      toast.success('CST Origem atualizado com sucesso!', {});

      return true

    } else {

      toast.warning(resp.data.msg, {});

    }

    return false

  }

  async handleDeleteCstOrigem(id: string) {

    let resp = await api_adm.delete(`/api/admin/codigos/cst/origem/${id}`)

    if (resp.data.ok) {

      toast.success('CST Origem deletado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

}

export const CstOrigemStore = new _CstOrigemStore();
